import { memo } from 'react'
import { Doc } from 'types'
import Styles from './ArticleList.module.scss'
import { Link } from 'react-router-dom'
import { getArticlePath } from 'utils/urlUtils'
import { ReactComponent as DocIcon } from 'assets/icons/doc.svg'

interface Props {
  articles: Doc[]
}

const ArticleList = ({ articles }: Props) => (
  <ul>
    {articles.map(({ title, slug, header_emoji }) => (
      <li className={Styles.listItem} key={slug}>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
        <Link title={title} to={getArticlePath({ slug: slug! })} className={Styles.link}>
          {header_emoji ? <span className={Styles.emoji}>{header_emoji}</span> : <DocIcon className={Styles.icon} />}
          {title}
        </Link>
      </li>
    ))}
  </ul>
)

const arePropsEqual = (prevProps: Props, nextProps: Props) => JSON.stringify(prevProps) === JSON.stringify(nextProps)

const MemoizedList = memo(ArticleList, arePropsEqual)

export { MemoizedList as ArticleList }
